import React from 'react';
import { ArrowLeft, Bell, House, IdCard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './IdentificationPage.css';

const IdentificationPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background" style={{ fontFamily: 'Arial' }}>
      <header className="relative bg-gradient-primary">
        <div className="flex items-center justify-between px-4 py-3">
          <button
            type="button"
            onClick={() => navigate('/home')}
            className="p-2 rounded-lg text-primary-foreground hover:bg-white/10"
            aria-label="Quay lại"
          >
            <ArrowLeft className="h-8 w-8" />
          </button>
          <img
            src={require('../assets/thuedinetu-BoU6E12Y.png')}
            alt="Logo"
            className="h-20 w-auto object-contain"
          />
          <div className="flex items-center gap-1">
            <button
              type="button"
              className="p-2 rounded-lg text-primary-foreground hover:bg-white/10"
              aria-label="Thông báo"
            >
              <Bell className="h-8 w-8" />
            </button>
            <button
              type="button"
              onClick={() => navigate('/home')}
              className="p-2 rounded-lg text-primary-foreground hover:bg-white/10"
              aria-label="Trang chủ"
            >
              <House className="h-8 w-8" />
            </button>
          </div>
        </div>
      </header>

      <main className="min-h-screen bg-gradient-to-b from-red-600 to-red-700 p-5 pb-10">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-7">
            <h1 className="text-[28px] font-bold text-white mb-2">Xác thực danh tính</h1>
          </div>

      <section className="id-scan-panel" aria-label="Khung quét CCCD">
            <div
              className="id-scan-frame"
              role="img"
              aria-label="Khung chữ nhật bốn góc, icon CCCD và tia quét chuyển động"
            >
              <span className="id-scan-corner top-left" aria-hidden="true" />
              <span className="id-scan-corner top-right" aria-hidden="true" />
              <span className="id-scan-corner bottom-left" aria-hidden="true" />
              <span className="id-scan-corner bottom-right" aria-hidden="true" />
              <div className="id-scan-icon" aria-hidden="true">
                <IdCard />
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default IdentificationPage;
